// extracted by css-extract-rspack-plugin
export default {"tutorial":"Tutorial__tutorial--drv3P","tutorialTitle":"Tutorial__tutorialTitle--oWtic","tutorialIcon":"Tutorial__tutorialIcon--ch9dd"};